// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shift-dialog__event-list-item__time{max-width:17ch}.schedule-drawer .schedule-dialog__event-list-item--is-in-drawer{min-height:24px;max-height:32px}", ""]);
// Exports
module.exports = exports;
